import React, { useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, img, fmt } from "./kit";

// SVIP ver: kisinin kalici SVIP seviyesini secilen seviyeye getirir (gercek yuklemesi + admin bonusu).
const req = async (path, body) => {
  const r = await fetch(`${baseURL}customFrame/admin/${path}`, {
    method: body ? "POST" : "GET",
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};
const inp = { padding: "8px 10px", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14 };

const SvipGrant = () => {
  const [id, setId] = useState("");
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const bul = async () => {
    if (!id.trim()) return;
    const r = await req(`svip?id=${encodeURIComponent(id.trim())}`);
    if (!r?.status) return window.alert(r?.message || "Bulunamadı");
    setD(r);
  };
  const ver = async (level) => {
    const ad = level ? d.svip.tiers[level - 1]?.label : "SVIP yok";
    if (!window.confirm(`${d.user.name} (${d.user.uniqueID}) → ${ad} yapılsın mı?`)) return;
    setBusy(true);
    const r = await req("svip", { id: d.user.uniqueID, level });
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setD({ ...d, svip: r.svip });
  };

  return (
    <>
      <PageHead title="SVIP Ver" sub="Kişinin ID'sini yaz, istediğin SVIP seviyesine bas. Gerçek yüklemesi + admin bonusu toplanır; yükleme gelir raporlarına girmez." />
      <div className="card">
        <div className="card-body">
          <div className="d-flex" style={{ gap: 8, marginBottom: 14 }}>
            <input style={{ ...inp, width: 220 }} placeholder="Kullanıcı ID (ör. 9997760)" value={id} onChange={(e) => setId(e.target.value)} onKeyDown={(e) => e.key === "Enter" && bul()} />
            <button className="btn btn-primary" onClick={bul}>
              Bul
            </button>
          </div>
          {d && (
            <>
              <div className="d-flex align-items-center" style={{ gap: 12, marginBottom: 14 }}>
                {d.user.image && <img src={img(d.user.image)} alt="" style={{ width: 48, height: 48, borderRadius: 24, objectFit: "cover" }} />}
                <div>
                  <b style={{ fontSize: 16 }}>{d.user.name}</b> <span style={{ color: "#6B7280" }}>ID {d.user.uniqueID}</span>
                  <div style={{ fontSize: 13 }}>
                    Şu an: <b style={{ color: "#7C3AED" }}>{d.svip.level ? d.svip.label : "SVIP yok"}</b> · puan {fmt(d.svip.points)} (gerçek yükleme {fmt(d.svip.realPoints)} + admin bonusu {fmt(d.svip.bonus)})
                  </div>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 8 }}>
                {d.svip.tiers.map((t, i) => {
                  const lv = i + 1;
                  const on = d.svip.level === lv;
                  return (
                    <button
                      key={lv}
                      disabled={busy}
                      onClick={() => ver(lv)}
                      className="btn"
                      style={{ border: on ? "2px solid #7C3AED" : "1px solid #E5E7EB", background: on ? "#F5F3FF" : "#fff", padding: "10px 6px", textAlign: "center" }}
                    >
                      <b style={{ color: "#7C3AED" }}>{t.label}</b>
                      <div style={{ fontSize: 11, color: "#6B7280" }}>{fmt(t.need)} puan</div>
                    </button>
                  );
                })}
                <button disabled={busy} onClick={() => ver(0)} className="btn btn-outline-danger" style={{ padding: "10px 6px" }}>
                  Admin SVIP'ini kaldır
                </button>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>
                SVIP kalıcıdır. Kişi kendi yüklemesiyle daha üst seviyeye çıkabilir. "Kaldır" sadece admin bonusunu siler; gerçek yüklemesinden gelen seviye kalır. Değişiklik uygulamada birkaç dakika içinde görünür.
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SvipGrant;
